import { atom } from 'recoil';

import { CampaignV2 } from '@/apis';

export const visibleForOptionSelectSheet = atom<boolean>({
  key: 'visibleForCampaignOptionSelector',
  default: false,
});

export const campaignOptionSelectSheet = atom<CampaignV2>({
  key: 'campaignOptionSelector',
  default: {
    id: 0,
    seller: '',
    seller_company_name: '',
    cs_channel: '',
    images: [
      {
        image: '',
        sequence: 0,
      },
    ],
    is_permanent: false,
    options: [
      {
        id: 0,
        name: '',
        stock_quantity: 0,
        price: 0,
        supply_price: 0,
        sub_options: [
          {
            id: 0,
            name: '',
            stock_quantity: 0,
            price: 0,
            supply_price: 0,
          },
        ],
      },
    ],
    stock_quantity: null,
    name: '',
    description: '',
    open_at: '',
    open_until: '',
    inventory_quantity: 0,
    is_sold_out: false,
    main_option_name: '',
    sub_option_name: '',
    category: {
      primary: '',
      secondary: '',
    },
    discount_info: null,
    discount_rate: 0,
    original_price: 0,
    manufacture_date: '',
    expiration_date: '',
    price: 0,
    delivery_company: '=',
    delivery_policy: {
      id: 0,
      name: '',
      shipping_fee: 0,
      remote_shipping_fee: 0,
      available_remote: false,
      is_free_shipping_used: false,
      min_price_for_free_shipping: 0,
      min_price_for_remote_discount: 0,
      discounted_remote_shipping_fee: 0,
      available_jeju: false,
      jeju_shipping_fee: 0,
      min_price_for_jeju_discount: 0,
      discounted_jeju_shipping_fee: 0,
    },
    brand_info: {
      email: '',
      company_name: '',
      business_number: '',
      ceo_name: '',
      online_sales_number: 0,
      location: '',
      cs_channel: '',
    },
    delivery_cut_off_time: '',
    exchange_refund_policy: '',
    return_address: '',
    return_address_detail: '',
    return_postcode: '',
    review_data: {
      counts: 0,
      avr_rating: 0,
    },
  },
});
